import { useEffect } from "react"
import { FieldValues, UseFormReturn } from "react-hook-form"
import { useIsHydrated } from "shared/lib/react/useIsHydrated"

import { useEvent } from "shared/lib/useEvent"

/**
 * Applies form values that only exist in the browser (URL params, store state)
 * once hydration has finished. Filter forms cannot initialize with them: parts of
 * an input are rendered conditionally on its value — the clear button for example —
 * so a prefilled first render would not match the prerendered HTML.
 */
export function useHydratedFormValues<TFieldValues extends FieldValues>(
  form: UseFormReturn<TFieldValues>,
  values: TFieldValues | undefined
) {
  const isHydrated = useIsHydrated()

  const applyValues = useEvent(() => {
    if (values) {
      form.reset(values)
    }
  })

  useEffect(() => {
    if (isHydrated) {
      applyValues()
    }
  }, [isHydrated, applyValues])
}
